import React from 'react';
import urfuLogo from '../../img/urfu_logo.svg';
import './Header.less';

const logos = [
  { src: urfuLogo, href: 'https://urfu.ru/' },
];

export default function Header() {
  return (
    <header className="header">
      <div className="logos-section">
        {logos.map((logo, i) => (
          <a className="logo-link" key={i} href={logo.href} target="_blank" rel="noreferrer">
            <img className="logo-img" src={logo.src} alt={logo.src} />
          </a>
        ))}
      </div>
    </header>
  );
}
